import colors from './colors'
import fontSize from './fontSize'
import mediaQuery from './mediaQuery'
import webkit from './webkit'

const styles = {
  colors,
  mediaQuery,
  fontSize,
  webkit,
}

export { elevation, typo } from './cssStyles'
export * from './utils/'
export default styles
export { default as colors } from './colors'
export { HSLColors } from './colors'
export { default as floatingBorder } from './floatingBorder'
export { default as mediaQuery } from './mediaQuery'
export { default as textEllipsis } from './textEllipsis'
export const A4_IN_PIXEL_X = 595
export const A4_IN_PIXEL_Y = 842
export * from './animation'
